import React from 'react';
import { Container } from 'react-bootstrap';
import { ArrowDown, ArrowUpRight } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import cat from '../Assets/Images/footer_cat.png';
import aws from '../Assets/Images/companies/aws.svg';
import resume from '../Assets/Documents/krish-resume.pdf';
import { Typewriter } from './Typewriter';

export const Banner = () => (
  <section className="banner" id="home">
    <Container className="hero-layout">
      <div className="hero-copy">
        <p className="hero-intro">Computer Science at Waterloo<span className="hero-graduation">Graduating April 2027</span></p>
        <div className="hero-heading"><h1>Hi, I'm Krish<span className="accent">.</span></h1></div>
        <Typewriter />
        <p className="hero-description">Currently interning at AWS, then heading into my final term at Waterloo.</p>
        <div className="hero-actions">
          <HashLink className="button button-primary" to="/#highlights">Explore my work <ArrowDown aria-hidden="true" /></HashLink>
          <a className="button button-secondary" href={resume} target="_blank" rel="noreferrer">My résumé <ArrowUpRight aria-hidden="true" /></a>
        </div>
        <Link className="hero-personal" to="/about"><span><strong>11.5s</strong> cubing PB</span><span>Brass: Birmingham fan</span><ArrowUpRight aria-hidden="true" /><span className="visually-hidden">More about me</span></Link>
      </div>
      <figure className="hero-art">
        <div className="hero-cat-scene"><span className="cat-orbit" aria-hidden="true" /><img src={cat} alt="An illustrated cat asleep on a stack of cushions" width="340" height="340" fetchpriority="high" /></div>
        <figcaption>Also a cat person.</figcaption>
      </figure>
      <HashLink className="hero-current" to="/career#aws">
        <span className="current-company-mark"><img src={aws} alt="AWS" width="40" height="28" /></span>
        <span className="current-role"><span>Software Engineering Intern at AWS <span aria-hidden="true">·</span> Fall 2026</span><strong>Building a dynamic rate limiter in Java</strong></span>
        <span className="current-detail">Journal Service Control Plane <ArrowUpRight aria-hidden="true" /></span>
      </HashLink>
    </Container>
  </section>
);
